export default __webpack_public_path__ + "static/media/image-pocket-borealis.799292df.jpg";